import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./CurrenciesContainer.less";
import { Col, Row, Tabs } from "antd";
import { fetchCurrencies } from "../../store/slices/currencies";
import { fetchCurrenciesDic } from "../../store/slices/rtkDictionaries";
import Currencies from "../../components/Currencies/Currencies";
import CrossCurrencies from "../../components/CrossCurrencies/CrossCurrencies";

const CurrenciesContainer = () => {
  const dispatch = useDispatch();
  const dicCurrencies = useSelector((state) => state.rtkDictionaries.dicCurrencies);
  const dicCurrenciesLoading = useSelector((state) => state.rtkDictionaries.dicCurrenciesLoading);
  const { currenciesData, currenciesDataLoading } = useSelector((state) => state.currencies);

  const { TabPane } = Tabs;

  useEffect(() => {
    dispatch(fetchCurrencies());
    dispatch(fetchCurrenciesDic());
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container_height">
      <div className="inner-row">
        <Row justify="space-between" align="middle">
          <Col>
            <h1>Курсы валют</h1>
          </Col>
        </Row>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Курсы валют" key="1">
            <Currencies
              currenciesData={currenciesData}
              currenciesDataLoading={currenciesDataLoading}
              dicCurrencies={dicCurrencies}
              dicCurrenciesLoading={dicCurrenciesLoading}
            />
          </TabPane>
          <TabPane tab="Кросс курсы" key="2">
            <CrossCurrencies
              dicCurrencies={dicCurrencies}
              dicCurrenciesLoading={dicCurrenciesLoading}
            />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default CurrenciesContainer;
